import { useState, useEffect } from "react";

const Toast = ({ message, type = "error", duration = 5000, onClose }) => {
	const [isVisible, setIsVisible] = useState(true);

	useEffect(() => {
		const timer = setTimeout(() => {
			setIsVisible(false);
			setTimeout(() => onClose?.(), 300);
		}, duration);

		return () => clearTimeout(timer);
	}, [duration, onClose]);

	const getToastStyles = () => {
		const baseStyles = "fixed top-4 right-4 z-50 max-w-sm w-full bg-gray-800 border rounded-lg shadow-lg transform transition-all duration-300 ease-in-out";
		
		if (type === "success") {
			return `${baseStyles} border-green-500 bg-green-900`;
		} else if (type === "warning") {
			return `${baseStyles} border-yellow-500 bg-yellow-900`;
		} else {
			return `${baseStyles} border-red-500 bg-red-900`;
		}
	};

	const getIconStyles = () => {
		if (type === "success") {
			return "text-green-400";
		} else if (type === "warning") {
			return "text-yellow-400";
		} else {
			return "text-red-400";
		}
	};

	const getIcon = () => {
		if (type === "success") {
			return (
				<svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
					<path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
				</svg>
			);
		} else if (type === "warning") {
			return (
				<svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
					<path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
				</svg>
			);
		} else {
			return (
				<svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
					<path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
				</svg>
			);
		}
	};

	if (!isVisible) return null;

	return (
		<div className={`${getToastStyles()} ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'}`}>
			<div className="flex items-start p-4">
				<div className={`flex-shrink-0 ${getIconStyles()}`}>
					{getIcon()}
				</div>
				<div className="ml-3 flex-1">
					<p className="text-sm font-medium text-gray-200">
						{message}
					</p>
				</div>
				<div className="ml-4 flex-shrink-0">
					<button
						onClick={() => {
							setIsVisible(false);
							setTimeout(() => onClose?.(), 300);
						}}
						className="inline-flex text-gray-400 hover:text-gray-200 focus:outline-none cursor-pointer"
					>
						<svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
							<path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
						</svg>
					</button>
				</div>
			</div>
		</div>
	);
};

export default Toast;
